import Parse from "parse";
import { getEnvironmentVariable } from "src/utils/environment";

Parse.initialize(getEnvironmentVariable("PARSE_APP_ID"));
Parse.serverURL = getEnvironmentVariable("PARSE_SERVER_URL");
window.Parse = Parse;
